<div class="flex flex-col gap-2">
  <div class="w-full">
    <label class="block text-sm font-medium text-gray-700 mb-1">Nome do Cliente</label>
    <input [(ngModel)]="customerName"
           (input)="onNameChange()"
           (keyup)="onNameKeyup($event)"
           pInputText
           autocomplete="off"
           class="w-full"
           type="text"
           id="customer-name-input"
           placeholder="Digite o nome do cliente">
  </div>

  <div class="w-full">
    <label class="block text-sm font-medium text-gray-700 mb-1">CPF/CNPJ</label>
    <input [(ngModel)]="customerDocument"
           (input)="onDocumentChange()"
           (keyup)="onDocumentKeyup($event)"
           pInputText
           autocomplete="off"
           class="w-full"
           type="text"
           id="customer-document-input"
           placeholder="Digite o CPF ou CNPJ">
  </div>

  <div class="w-full mt-2">
    <button (click)="confirmCustomer()"
            pButton
            type="button"
            label="Confirmar (Enter)"
            class="w-full bg-orange-600 hover:bg-orange-700 text-white">
    </button>
  </div>
</div>

